import SSO from './SSO.class'

export {
  // eslint-disable-next-line import/prefer-default-export
  SSO,
}
